module.exports = __webpack_public_path__ + "img/empty-contacts@2x.57dacca1.png";